import { formatElapsedSeconds } from "@lib/common/utils/formatElapsedSeconds";
import type { TextProps } from "@mantine/core";
import { Text } from "@mantine/core";
import { useEffect, useState } from "react";

/** A live timer for something still running, where TimeAgo's "45 seconds ago" would read as past. */
export default function ElapsedTime({
  since,
  interval = 1000,
  ...props
}: { since: Date; interval?: number } & TextProps) {
  const [elapsed, setElapsed] = useState(() => (Date.now() - since.getTime()) / 1000);

  // Recomputed from `since` rather than incremented, so it stays true while the tab is backgrounded.
  useEffect(() => {
    setElapsed((Date.now() - since.getTime()) / 1000);
    const timer = setInterval(() => setElapsed((Date.now() - since.getTime()) / 1000), interval);
    return () => clearInterval(timer);
  }, [since, interval]);

  return (
    <Text component="span" {...props}>
      {formatElapsedSeconds(elapsed)}
    </Text>
  );
}
